module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/calendar-check.svg?7f12ecb0734d0dde6c69b61b7d9979a0";